export const QUOTATIONS_ROUTE = "/quotations";
